
    import { Component, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import BriefDetail from '@/components/Impfverwaltung/Kartei/BriefDetail.vue';
    import DekursDetail from '@/components/Impfverwaltung/Dekurs/DekursDetail.vue';
    import DekursTabitem from '@/components/Impfverwaltung/Dekurs/DekursTabitem.vue';
    import Druckansicht from '@/components/Impfverwaltung/Rechnung/Druckansicht.vue';
    import ElgaPatientDetail from '@/components/Impfverwaltung/Patient/ElgaPatientDetail.vue';
    import ElgaPatientSuche from '@/components/Impfverwaltung/Patient/ElgaPatientSuche.vue';
    import ErinnerungenTabitem from '@/components/Impfverwaltung/Erinnerungen/ErinnerungenTabitem.vue';
    import ImpfempfehlungenTabitem from '@/components/Impfverwaltung/Impfempfehlungen/ImpfempfehlungenTabitem.vue';
    import ImpfungDetail from '@/components/Impfverwaltung/Kartei/ImpfungDetail.vue';
    import KarteiDataTable from '@/components/Impfverwaltung/Kartei/KarteiDataTable.vue';
    import Karteieintrag from '@/types/Karteieintrag';
    import LeistungseintragDetail from '@/components/Impfverwaltung/Kartei/LeistungseintragDetail.vue';
    import OffenTabitem from '@/components/Impfverwaltung/Offen/OffenTabitem.vue';
    import PatUntersuchung from '@/types/PatUntersuchung';
    import PatientCardDialog from '@/components/Impfverwaltung/Patient/PatientCardDialog.vue';
    import PatientDetail from '@/components/Impfverwaltung/Patient/PatientDetail.vue';
    import PatientDruckDetail from '@/components/Impfverwaltung/Patient/PatientDruckDetail.vue';
    import PatientEtikettenDetail from '@/components/Impfverwaltung/Patient/PatientEtikettenDetail.vue';
    import PatientOverview from '@/components/Impfverwaltung/Patient/PatientOverview.vue';
    import PatientSearch, { PatientSearchItem } from '@/components/Impfverwaltung/Patient/PatientSearch.vue';
    import RechnungSearch, {RechnungSearchItem} from '@/components/Impfverwaltung/Patient/RechnungSearch.vue';
    import PatientUebertragung from '@/components/Impfverwaltung/Patient/PatientUebertragung.vue';
    import PatientenregisterSuche from '@/components/Impfverwaltung/Patient/PatientenregisterSuche.vue';
    import PlaeneDatatable from '@/components/Impfverwaltung/Plaene/PlaeneDatatable.vue';
    import PlaeneTabitem from '@/components/Impfverwaltung/Plaene/PlaeneTabitem.vue';
    import PlanDetailmaske from '@/components/Impfverwaltung/Plaene/PlanDetailmaske.vue';
    import Planimpfung from '@/types/Planimpfung';
    import Rechnung from '@/components/Impfverwaltung/Rechnung/Rechnung.vue';
    import RechnungenDatatable from '@/components/Impfverwaltung/Rechnung/RechnungenDatatable.vue';
    import RechnungenTabitem from '@/components/Impfverwaltung/Rechnung/RechnungenTabitem.vue';
    import RezepteintragDetail from '@/components/Impfverwaltung/Kartei/RezepteintragDetail.vue';
    import TextDetail from '@/components/Impfverwaltung/Kartei/TextDetail.vue';
    import UntersuchungDetail from '@/components/Impfverwaltung/Kartei/UntersuchungDetail.vue';
    import UntersuchungenTabitem from '@/components/Impfverwaltung/Untersuchungen/UntersuchungenTabitem.vue';
    import User from '@/types/User';
    import Warteliste from '@/components/Impfverwaltung/Warteliste/Warteliste.vue';
    import WartelisteDetail from '@/components/Impfverwaltung/Warteliste/WartelisteDetail.vue';
    import ZurKassaDetail from '@/components/Impfverwaltung/Kassa/ZurKassaDetail.vue';
    import { ImpfstoffeSelect } from '@/store/impfstoff';
    import { LoadWarteListePayload } from '@/store/warteliste';
    import { PlanItem } from '@/types/Reiseplan';
    import { Resettable } from '@/types/Components';
    import {WartelisteFilter, WartelisteState} from '@/store/types';
    import { confirmSwal } from '@/helper/swals';
    import { SystemEinstellung, SystemEinstellungKey } from '@/types/Einstellung';
    import DiagnoseneintragDetail from '@/components/Impfverwaltung/Kartei/DiagnoseneintragDetail.vue';
    import AnamneseneintragDetail from '@/components/Impfverwaltung/Kartei/AnamneseneintragDetail.vue';
    import PatientCardInfoDialog from '@/components/Impfverwaltung/Patient/PatientCardInfoDialog.vue';
    import Patient from '@/types/Patient';
    import _ from 'lodash';
    import {NotificationInterface} from '@/services/Response';

    @Component({
        components: {
            AnamneseneintragDetail,
            DiagnoseneintragDetail,
            BriefDetail,
            DekursDetail,
            DekursTabitem,
            Druckansicht,
            ElgaPatientDetail,
            ElgaPatientSuche,
            ErinnerungenTabitem,
            ImpfempfehlungenTabitem,
            ImpfungDetail,
            KarteiDataTable,
            LeistungseintragDetail,
            OffenTabitem,
            PatientCardDialog,
            PatientDetail,
            PatientDruckDetail,
            PatientEtikettenDetail,
            PatientOverview,
            PatientSearch,
            PatientUebertragung,
            PatientenregisterSuche,
            PlaeneDatatable,
            PlaeneTabitem,
            PlanDetailmaske,
            Rechnung,
            RechnungenDatatable,
            RechnungenTabitem,
            RezepteintragDetail,
            TextDetail,
            UntersuchungDetail,
            UntersuchungenTabitem,
            Warteliste,
            WartelisteDetail,
            ZurKassaDetail,
            RechnungSearch,
            PatientCardInfoDialog
        },
        computed: {
            ...mapState('patient', [
                'dialogs',
                'patientData',
                'elgaPatient',
                'impfungen',
                'erinnerungen',
                'patientDataNew',
                'patientImpfungNew',
                'tempPatientData',
                'selected_text',
                'selected_impfeintrag',
                'selected_rezepteintrag',
                'selected_leistungseintrag',
                'selected_brief',
                'selected_untersuchung',
                'selected_diagnose',
                'selected_anamnese',
                'showAllePatientInfo'
            ]),
            ...mapState('authentication', ['user']),
            ...mapState('session', ['warteliste']),
            ...mapState('warteliste', { wartelisteFilter: 'filter' }),
            ...mapState('warteliste', { wartelisteDialogs: 'dialogs' }),
            ...mapState('warteliste', ['wartelisteItem']),
            ...mapGetters('authentication', ['isAllowed', 'getSystemEinstellung', 'arbeitsplatz']),
            ...mapGetters('patient', [
                'getNrPlaene',
                'getNrOffeneImpfungenUndUntersuchungen',
                'getNrUntersuchungen',
                'getNrRechnungen',
                'getNrErinnerungen',
                'untersuchungenEintraege',
            ]),
        },
        methods: {
            ...mapActions('impfstoff', ['loadImpfstoffe']),
            ...mapActions('session', ['setShowWarteliste']),
            ...mapActions('patient', [
                'loadPatient',
                'patientDetail',
                'patientNew',
                'closePatient',
                'patientDruck',
                'patientEtiketten',
                'printUntersuchung',
                'printUntersuchungsanforderung'
            ]),
            ...mapActions('leistungen', ['loadLeistungen']),
            ...mapActions('laender', ['loadLaender']),
            ...mapActions('warteliste', ['loadWarteliste']),
            ...mapMutations('warteliste', ['setEdit']),
            ...mapMutations('patient', [
                'setNeueImpfung',
                'setDialogImpfeintragEdit',
                'setDialogImpfungNachtrag',
                'setDialogElgaPatient',
                'setDialogText',
                'setDialogPatientUebertragung',
                'setDialogElgaSuche',
                'setDialogBrief',
                'setDialogDekurs',
                'setDialogUntersuchung',
                'setDialogWarteliste',
                'setDialogRechnung',
                'setSelectedOffen',
                'setSelectedOffenNext',
                'setSelectedUntersuchung',
                'setElgaPatientAnlage',
                'setDialogSsnoSearch',
                'setDialogEcard',
                'setDialogEcardInfo',
                'setDialogZurKassa',
                'setShowAllePatientInfo',
            ]),
        },
    })
    export default class Home extends Vue {
        public user!: User | null;
        public warteliste!: boolean;
        public patientData!: any;
        public wartelisteFilter!: WartelisteFilter;
        public wartelisteDialogs!: WartelisteState;
        public loadPatient!: (payload: { patnr: number }) => Promise<void>;
        public untersuchungenEintraege!: Karteieintrag[];
        public loadWarteliste!: (payload?: LoadWarteListePayload) => void;
        public loadImpfstoffe!: (payload: ImpfstoffeSelect) => void;
        public loadLaender!: () => void;
        public loadLeistungen!: () => void;
        public setSelectedUntersuchung!: (eintrag: Karteieintrag) => void;
        public setSelectedOffen!: (items: PlanItem<Planimpfung | PatUntersuchung>[]) => void;
        public setSelectedOffenNext!: () => void;
        public setDialogUntersuchung!: (visible: boolean) => void;
        public setShowWarteliste!: (payload: boolean) => void;
        public setShowAllePatientInfo!: (payload: boolean) => void;
        public printUntersuchung!: (payload?: PatUntersuchung | PatUntersuchung[]) => void;
        public getSystemEinstellung!: <T>(parameter: SystemEinstellungKey) => SystemEinstellung<T>;
        public printUntersuchungsanforderung!: (payload: { patient:Patient, untersuchungen: any[], onlytoday: boolean }) => void;

        public arbeitsplatz!:any;
        public showAllePatientInfo!:any;

        public $refs!: {
            search: Resettable;
            searchRechnung: Resettable;
            tabs: Vue;
            dekurs: Resettable;
            erinnerungen: Resettable;
            warteliste: Resettable;
            [key: string]: Vue;
        };

        public showWarteliste = true;
        public tab: string | null = null;
        public searchResult: PatientSearchItem[] = [];
        public searchRechnungResult: RechnungSearchItem[] = [];

        public beforeMount(): void {
            this.showWarteliste = this.warteliste;
        }

        public mounted(): void {
            if (this.user?.hasRoles(['anwender', 'admin', 'system'])) {
                this.loadWarteliste();
                this.loadImpfstoffe({
                    chargen: true,
                    elgaimpfstoffe: true,
                    immunziationTarget: true,
                    impfschemen: true,
                    teilimpfungen: true,
                });
                this.loadLaender();
                this.loadLeistungen();
            }

            this.showWarteliste = this.warteliste;
        }

        public onChangeWartelisteFilter(): void {
            this.loadWarteliste({
                fertig: this.wartelisteFilter.fertig,
                arbeitsplatz: this.wartelisteFilter.arbeitsplatz ? this.arbeitsplatz : this.wartelisteFilter.arbeitsplatz,
                wartet: this.wartelisteFilter.wartet,
            });
        }

        public onChangeWartelisteFilterWartet(value: boolean): void {
            var wartet = false;
            var atrbeitsplatz = false;

            if (value) {
                wartet = true;
                atrbeitsplatz = false;
            }

            this.loadWarteliste({
                fertig: this.wartelisteFilter.fertig,
                arbeitsplatz: atrbeitsplatz,
                wartet: wartet,
            });
        }

        public onChangeWartelisteFilterArbeitsplatz(value: boolean): void {
            var wartet = false;
            var atrbeitsplatz = false;

            if (value) {
                wartet = false;
                atrbeitsplatz = this.arbeitsplatz;
            }

            this.loadWarteliste({
                fertig: this.wartelisteFilter.fertig,
                arbeitsplatz: atrbeitsplatz,
                wartet: wartet,
            });
        }

        public onClickToggleWarteliste(): void {
            this.showWarteliste = !this.showWarteliste;
            this.setShowWarteliste(this.showWarteliste);
        }

        @Watch('patientData.patnr')
        public onChangePatnr(patient: boolean): void {
            this.tab = patient ? 'plaene' : null;

            if (!this.tab && this.$refs.tabs) {
                const [tabs] = this.$refs.tabs.$children;
                if (tabs) {
                    (tabs.$children as (Vue & { isActive: boolean })[])
                        .forEach((tab) => tab.isActive = false);
                }
            }
        }

        public onSelectPatient(selection: { id: number } | null): void {
            if (selection) {
                this.loadPatient({ patnr: selection.id })
                    .then(() => {
                        this.searchResult = [];
                        this.searchRechnungResult = [];
                        this.$refs.search.reset();
                        this.$refs.searchRechnung.reset();
                    });
            }
        }

        @Watch('tab')
        public onChangeTab(tab: string): void {
            const ref = this.$refs[tab] as Resettable;

            if (ref && ref.reset) {
                ref.reset();
            }
        }

        @Watch('patientData.dekurs')
        public onChangePatientDataDekurs(): void {
            this.$refs.dekurs.reset();
        }

        @Watch('dialogs.rechnung')
        public onChangeDialogRechnung(visible: boolean): void {
            if (!visible) {
                this.$refs.warteliste.reset();
            }
        }

        public onClickSelectOffen(items: PlanItem<Planimpfung | PatUntersuchung>[]): void {
            /*if (this.getSystemEinstellung('untersuchungsanforderung_aktiv').eq('j')) {
                const untersuchungen = items.filter((item) => item.isUntersuchung);
                if (untersuchungen.length > 0) {
                    confirmSwal(
                        'Untersuchung',
                        'Soll eine Untersuchungsanforderung gedruckt werden?',
                        'Drucken',
                        'Abbrechen'
                    ).then(({ isConfirmed }) => {
                        if (isConfirmed) {
                            this.printUntersuchung(untersuchungen.map((item) => item.asUntersuchung));
                        }
                    });
                }
            }*/

            if (this.getSystemEinstellung('muw').isEnabled()) {
                const untersuchungen = items.filter((item) => item.isUntersuchung);
                if (untersuchungen.length > 0) {
                    const retval :any[] = [];
                    _.forEach(untersuchungen, (item: any) => {
                        retval.push(item.data);
                    });
                    //this.printUntersuchungsanforderung({patient: this.patientData, untersuchungen: retval, onlytoday: false});
                }
            }

            this.setSelectedOffen(items);
            this.setSelectedOffenNext();
        }

        public onClickEditUntersuchung(eintrag: Karteieintrag | PatUntersuchung): void {
            if (eintrag instanceof PatUntersuchung) {
                const { patuntersuchung_id } = eintrag as PatUntersuchung;

                const untersuchungEintrag = this.untersuchungenEintraege.find(({ untersuchung }) => {
                    return untersuchung?.patuntersuchung_id === patuntersuchung_id;
                });

                if (untersuchungEintrag) {
                    this.setSelectedUntersuchung(untersuchungEintrag);
                } else {
                    this.setSelectedUntersuchung(new Karteieintrag({ untersuchung: eintrag }));
                }
            } else {
                this.setSelectedUntersuchung(eintrag);
            }

            this.setDialogUntersuchung(true);
        }

        get getArbeitsplatzName():string {
            if (this.arbeitsplatz) {
                return this.arbeitsplatz.arbeitsplatz;
            } else {
                return 'Arbietsplatz';
            }
        }

        @Watch('wartelisteFilter.wartet')
        public onChangeFilterWartet() {
            if (this.wartelisteFilter.wartet) {
                this.wartelisteFilter.arbeitsplatz = false;
            }
        }

        @Watch('wartelisteFilter.arbeitsplatz')
        public onChangeFilterArbeitsplatz() {
            if (this.wartelisteFilter.arbeitsplatz) {
                this.wartelisteFilter.wartet = false;
            }
        }

        public onClickTogglePatientOverview() {
            if (this.showAllePatientInfo) {
                this.setShowAllePatientInfo(false);
            } else {
                this.setShowAllePatientInfo(true);
            }
        }
    }
